import en_US from './en_US';
import de_DE from './de_DE';
import zh_CN from './zh_CN';
import fr_FR from './fr_FR';
import it_IT from './it_IT';
import es_ES from './es_ES';

export type SupportLocale = 'en_US' | 'de_DE' | 'zh_CN' | 'fr_FR' | 'it_IT' | 'es_ES';

export const defaultLocale: SupportLocale = 'en_US';

/**
 * @desc dayjs 设置 locale 值
 */
export const localeMap: { [key in SupportLocale]: string } = {
    en_US: 'en',
    de_DE: 'de',
    zh_CN: 'zh-cn',
    fr_FR: 'fr',
    it_IT: 'it',
    es_ES: 'es',
};

export const localeData = {
    en_US,
    de_DE,
    zh_CN,
    fr_FR,
    it_IT,
    es_ES,
};
